import versionInfo from "./version.json";

export const environment = {
  production: true,
  BASE_URL: "https://solicitudesagd.com/api-sol/",
  cookieDomain: ".solicitudesagd.com",
  version: `${versionInfo.version}`,

  // reCAPTCHA V2 (mantener durante transición)
  reCaptchaKey: "6Le7S7QoAAAAAFRW6o5gCQivLNrLLYXzo-v3hf0a",
  captcha: {
    sitekey: "6Ld6UtwrAAAAAOv_eDEQbJ5c7f2ftS7lhgmNGg8b",
  },
  // Se deshabilita por problemas de implementación en servidores de PROD en AGD.
  disableCaptcha: false,

  // reCAPTCHA Enterprise (GCP) - Producción
  reCaptchaEnterprise: {
    enabled: true, // Habilitado con datos reales
    keyId: "6LeZEIcsAAAAAEh1hkoc06Q8MGL7Bdd5P4tYtEs2", // Clave proporcionada por el cliente
    projectId: "project-343de3fc-aedb-41ee-ba6",
    threshold: 0.7, // Más estricto en producción
    apiUrl: "https://www.google.com/recaptcha/enterprise.js",
    actions: {
      login: "LOGIN",
      recoverPassword: "RECOVER_PASSWORD",
      register: "REGISTER",
      contact: "CONTACT",
    },
  },
};
